import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { EmailInput, PasswordInput } from '../../../global/components/forms'
import PqNLogo from "../../../global/components/logo/PqNLogo";
import SwitchComponent from "../../../global/components/base/SwitchComponent";
import {redirectToPage} from "../../../global/utils/routerUtils";
import { testValidEmail } from "../../../global/utils/helpUtils";

const UserLoginForm = ({
  handleChange,
  handleSubmit,
  user,
  redirectPath,
  titleView = 'Sign In',
  errorView = '',
}) => {
  const location = useLocation();
  let point = '';
    const loc_arr = location?.search ? location.search.split('/') : [];
    if (loc_arr?.length) {
        point = loc_arr[loc_arr.length - 2];
    }

    const type = point === 'instructor' ? 'Instructor' : point === 'learn' ? 'Student' : '';
    const sub_text = type === 'Student' ? 'Assessment Platform' : type === 'Instructor' ? 'Assessment Creator' : '';

    const [disabled, setDisabled] = useState(false);
    useEffect(() => {
        setDisabled(!(user?.password?.length >= 8 && user?.username?.length && testValidEmail(user?.username)));
    }, [user]);

  return (
      <div className="full-white-page content-in-center pt-8">
          <div className="register-form-block">
              <div className="logo-slot">
                  <PqNLogo className="h-[80px]"/>
              </div>
              <div className="title-and-switch">
                  <h1 className={`${titleView === 'Sign In' ? 'pb-4' : ''} text-gray-900 text-center`}> {titleView} </h1>
                  {errorView ? <p className="text-center text-red-600">{errorView}</p> : null}
                  <SwitchComponent
                      leftTitle="Register"
                      rightTitle="Sign In"
                      leftIsActive={false}
                      rightIsActive={'/user/login' === location.pathname}
                      leftAction={() => { redirectToPage('/user/register') }}
                      rightAction={() => { redirectToPage('/user/login') }}/>
              </div>
              <div className="p-4">
                  <form name="userForm" onSubmit={handleSubmit}>
                      <p className="pb-2 text-gray-700">Email Address</p>
                      <EmailInput
                          name="username"
                          value={user.username}
                          change={handleChange}
                          required={true}
                          onTheFlyCheck={false}
                      />
                      <p className="pb-2 text-gray-700">Password</p>
                      <PasswordInput
                          name="password"
                          value={user.password}
                          change={handleChange}
                          required={true}
                      />
                      <div className="flex justify-end">
                          <Link
                              className="text-xs italic text-blue-600 mb-2"
                              to={{
                                  pathname: "/user/forgot-password",
                                  state: location.state
                              }}
                          >
                              Forgot Password?
                          </Link>
                      </div>
                      <div className="py-2">
                          <button
                              disabled={disabled}
                              className="btn-blue w-full"
                              type="submit">
                              Sign in
                          </button>
                      </div>
                  </form>

                  <div className="mb-2 mt-4 flex_row_center">
                      <p className="text-sm mb-2 text-stone-500 pt-2">Need an account?</p>
                      {redirectPath ?
                          <Link
                              className="italic text-blue-600 text-sm ml-1"
                              to={`/user/register/${redirectPath}`}
                          >
                              Register
                          </Link>
                          :
                          <Link
                              className="italic text-blue-600 text-sm ml-1"
                              to={{
                                  pathname: "/user/register"
                                  , state: location.state
                              }}
                          >
                              Register
                          </Link>
                      }
                  </div>
              </div>
          </div>
      </div>
  )
}

UserLoginForm.propTypes = {
    handleChange: PropTypes.func.isRequired
    , handleSubmit: PropTypes.func.isRequired
    , user: PropTypes.object.isRequired
}

export default UserLoginForm;
